export default __webpack_public_path__ + "static/media/03237c525afb3b2bcd30a7e25472e4131581611555073.3c8ff8fd.webp";